// extracted by mini-css-extract-plugin
module.exports = {"investmentCardInput":"index-module--investmentCardInput--28Xx6","radioCheck":"index-module--radioCheck--3f72A","costCardInput":"index-module--costCardInput--2frd0"};